const puzzle = {
  id: "uXN8AXD4ca7sdiddPIGn",
  name: "The Boundaries of Mystery",
  rebuses: [
    {
      style: {},
      clues: [
        {
          dependsOn: [],
          id: "cb7ab4f1-caeb-43d7-b6e0-b2c0b2ef6413",
          helperText: "Who is this actress who played in Fast and Furious?",
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                value: "Eva Mendes",
                id: "9b535866-42b8-447c-b715-478c0e0bd84f",
              },
            ],
            type: "text",
            solvedText: "Eva Mendes",
          },
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              value: "rbz55o9r.png",
              id: "56860815-4bff-4909-9efe-95c23a327a5e",
              type: "image",
              style: {
                width: "calc(50% - 10px)",
                marginRight: "-5px",
              },
              subtext: "",
            },
            {
              style: {
                width: "calc(50% - 10px)",
                marginLeft: "-5px",
              },
              value: "b9wVPtIo.png",
              type: "image",
              id: "eb051392-7f41-4e5b-8314-55edcdeb9127",
              subtext: "",
            },
            {
              style: {
                width: "calc(80% - 10px)",
              },
              subtext: "",
              value: "uBfT3gXD.png",
              type: "image",
              id: "16237f29-7065-4a1c-9f98-b693e7d1a174",
            },
          ],
          clueGroup: 0,
        },
        {
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 0,
          dependsOn: [],
          clueValues: [
            {
              value: "P38pvf9T.png",
              id: "56860815-4bff-4909-9efe-95c23a327a5e",
              type: "image",
              style: {
                width: "calc(50% - 10px)",
                marginRight: "-5px",
              },
              subtext: "",
            },
            {
              style: {
                width: "calc(50% - 10px)",
                marginLeft: "-5px",
              },
              value: "DjjacRRu.png",
              type: "image",
              id: "eb051392-7f41-4e5b-8314-55edcdeb9127",
              subtext: "",
            },
            {
              style: {
                width: "calc(80% - 10px)",
              },
              subtext: "",
              value: "uBfT3gXD.png",
              type: "image",
              id: "16237f29-7065-4a1c-9f98-b693e7d1a174",
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "William H. Macy",
                id: "58b91de4-2ef4-4385-b72c-eb6b9999d0e2",
              },
              {
                value: "William Hall Macy",
                id: "edb29fa8-b8a0-418a-868b-798f1cee2a37",
              },
              {
                id: "0aabee5e-9725-40da-b222-4cbf4a00c084",
                value: "William Hall Macy Jr.",
              },
              {
                id: "8542bc51-abc8-42df-8a93-a35cc1ca8ab5",
                value: "William H Macy",
              },
              {
                id: "a493d8fd-72e8-44e7-bd57-089101c99a0c",
                value: "William Macy",
              },
              {
                id: "03fa9be3-c042-4cc7-a98f-56818199f7a4",
                value: "Will Macy",
              },
              {
                id: "071b735f-e416-42ce-a5a3-81dba134eb21",
                value: "Will H. Macy",
              },
            ],
            solvedText: "William H. Macy",
          },
          id: "2706f0e2-cdb6-403e-8185-908ab89da0db",
          helperText: "Who is this actor who played in Fargo?",
          subtext: "",
        },
        {
          id: "031381be-f24f-4580-a0c3-7711b5fab336",
          helperText: "Who is this actress who played in The Queen's Gambit?",
          clueValues: [
            {
              value: "Hgyi4xjP.png",
              id: "56860815-4bff-4909-9efe-95c23a327a5e",
              type: "image",
              style: {
                width: "calc(50% - 10px)",
                marginRight: "-5px",
              },
              subtext: "",
            },
            {
              style: {
                width: "calc(50% - 10px)",
                marginLeft: "-5px",
              },
              value: "zeVKkoLh.png",
              type: "image",
              id: "eb051392-7f41-4e5b-8314-55edcdeb9127",
              subtext: "",
            },
            {
              style: {
                width: "calc(80% - 10px)",
              },
              subtext: "",
              value: "uBfT3gXD.png",
              type: "image",
              id: "16237f29-7065-4a1c-9f98-b693e7d1a174",
            },
          ],
          dependsOn: [],
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          subtext: "",
          solutionInfo: {
            possibleSolutions: [
              {
                value: "Anya Taylor-Joy",
                id: "d35685d9-6f28-42cc-8749-bf19a0b65714",
              },
              {
                value: "Anya Taylor Joy",
                id: "01fe1092-2929-4850-b373-c04488754b8b",
              },
              {
                value: "Anya-Josephine Marie Taylor-Joy",
                id: "b4c94529-1fd7-4f93-b73c-ad690856dc16",
              },
            ],
            type: "text",
            solvedText: "Anya Taylor-Joy",
          },
        },
        {
          dependsOn: [
            {
              value: "cb7ab4f1-caeb-43d7-b6e0-b2c0b2ef6413",
              id: "e4743daa-af67-43b4-9621-d5c5d7ffef2e",
            },
            {
              id: "2e8b308c-0055-4f22-89e8-d139b5d26de1",
              value: "2706f0e2-cdb6-403e-8185-908ab89da0db",
            },
            {
              value: "031381be-f24f-4580-a0c3-7711b5fab336",
              id: "a9ec968b-bc72-4a38-9000-dfb29f57e65f",
            },
          ],
          clueGroup: 0,
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          clueValues: [
            {
              subtext: "",
              id: "aa354b5c-9542-40c7-814b-5efc44a18dcf",
              value: "Place of birth",
              type: "text",
              style: {
                width: "calc(40% - 10px)",
              },
            },
          ],
          subtext: "",
          id: "d77232fb-dbc0-47e8-965c-3cda463d6f85",
          style: {
            width: "calc(70% - 10px)",
          },
          helperText: "Where are these actors born?",
        },
      ],
      solutionInfo: {
        possibleSolutions: [
          {
            id: "01a00664-c05e-47ad-a9d1-a2458612729f",
            value: "Miami",
          },
        ],
        type: "text",
        solvedText: "Miami",
      },
      id: "0f868670-ae9d-4175-bedf-b34a72b0d940",
    },
    {
      clues: [
        {
          id: "34c5b7ad-130e-46c0-9f64-9d696f1374ec",
          helperText:
            "Put all 8 balls on the scale so that the scale is in balance. After that figure out which two 4-letter words can be derived from letters on each side.",
          clueValues: [
            {
              value: "RichPortWeighingScale",
              type: "customComponent",
              subtext: "",
              id: "ddae7633-ed05-4c28-ae12-d93ef6d9eced",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          solutionInfo: {
            type: "text",
            possibleSolutions: [],
            solvedText: "",
          },
          subtext: "",
          clueGroup: 0,
          style: {
            width: "calc(70% - 10px)",
          },
          dependsOn: [],
        },
      ],
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "655b894d-62a2-4b81-9b71-3621bc1312fd",
            value: "Puerto Rico",
          },
        ],
        solvedText: "Puerto Rico",
      },
      id: "f979aecd-a125-43e8-b01d-7330185754fe",
    },
    {
      style: {},
      solutionInfo: {
        type: "text",
        possibleSolutions: [
          {
            id: "20a5bf3b-5a4b-45af-97e9-f549109a8059",
            value: "John Smith",
          },
        ],
        solvedText: "John Smith",
      },
      id: "6d02974e-0ade-4a1d-9d93-ac9334719eb5",
      clues: [
        {
          helperText: "A generic name he sometimes used",
          style: {
            width: "calc(33% - 10px)",
          },
          clueValues: [
            {
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "",
              id: "e992be8d-54ef-4dba-9445-841a27192841",
              type: "text",
              value: "Doctor Who alias",
            },
          ],
          solutionInfo: {
            solvedText: "",
            possibleSolutions: [],
            type: "text",
          },
          dependsOn: [],
          subtext: "",
          clueGroup: 0,
          id: "6432d3e8-efce-4241-b2bd-5236a63d897b",
        },
        {
          dependsOn: [],
          clueGroup: 0,
          subtext: "",
          id: "c9ca3975-44b8-4519-9efb-3857752f48f5",
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            solvedText: "",
            type: "text",
            possibleSolutions: [],
          },
          clueValues: [
            {
              subtext: "",
              id: "d7fc0e53-cde2-439d-8345-c29879900f38",
              value: "English explorer",
              type: "text",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          helperText: "His statue is in Jamestown, Virginia.",
        },
      ],
    },
    {
      solutionInfo: {
        solvedText: "Bermuda triangle",
        type: "text",
        possibleSolutions: [
          {
            value: "Bermuda triangle",
            id: "ca5de5f4-ad25-4b25-9a21-c7a9431099e4",
          },
          {
            id: "77083ce5-2c83-4275-8c34-4c8b3fdaff84",
            value: "Triangle",
          },
        ],
      },
      id: "c948a4a3-3117-4898-aff1-2c615fa4aecc",
      style: {},
      clues: [
        {
          helperText: "",
          style: {
            width: "calc(33% - 10px)",
          },
          solutionInfo: {
            type: "text",
            solvedText: "",
            possibleSolutions: [],
          },
          clueValues: [
            {
              id: "fdba13a4-1afa-4ccb-a4c4-be1b94d0e561",
              subtext: "",
              type: "text",
              value: "Miami",
              style: {
                width: "calc(100% - 10px)",
              },
            },
          ],
          clueGroup: 0,
          subtext: "",
          id: "5404c1ff-009f-4c89-b270-9bb3b4eb6f02",
          dependsOn: [],
        },
        {
          dependsOn: [],
          clueGroup: 0,
          style: {
            width: "calc(33% - 10px)",
          },
          helperText: "",
          solutionInfo: {
            possibleSolutions: [
              {
                value: "San Juan",
                id: "0d47cdb5-62ea-41ff-accc-aba35d049b43",
              },
            ],
            type: "text",
            solvedText: "San Juan",
          },
          clueValues: [
            {
              type: "text",
              subtext: "Capital",
              style: {
                width: "calc(100% - 10px)",
              },
              id: "2231ef38-ca55-4bf3-a170-5163f2d68aba",
              value: "Puerto Rico",
            },
          ],
          subtext: "",
          id: "c48f6224-f733-44c7-9077-9079b1a50505",
        },
        {
          clueValues: [
            {
              value: "RL7Vmm5S.png",
              type: "image",
              style: {
                width: "calc(100% - 10px)",
              },
              subtext: "John Smith's beach",
              id: "593bf6b9-c5c2-4a55-a8d7-b91fe081f91a",
            },
          ],
          style: {
            width: "calc(33% - 10px)",
          },
          clueGroup: 0,
          subtext: "",
          id: "ed5c7f44-bd1d-4161-b15d-0a0bc0860f5b",
          solutionInfo: {
            type: "text",
            possibleSolutions: [
              {
                value: "Bermuda",
                id: "c7589da4-1bb8-4507-9174-fdc5db57a2c0",
              },
            ],
            solvedText: "Bermuda",
          },
          dependsOn: [],
          helperText: "",
        },
      ],
    },
  ],
};

export default puzzle;
